
function closeUVPopup() {
  document.getElementById("uv-popup").style.display = "none";
  localStorage.setItem("uvPopupClosed", "true");
}

function showUVPopup() {
  if (localStorage.getItem("uvPopupClosed")) return;

  setTimeout(() => {
    document.getElementById("uv-popup").classList.remove("hidden");
  }, 4000);
}

async function loadUVPopup() {
  try {
    const res = await fetch("https://api.weatherapi.com/v1/current.json?key=7ef1678d45804f85ad8100731261803&q=auto:ip");
    const data = await res.json();

    const temp = data.current.temp_c;
    const uv = data.current.uv;
    const location = data.location.name;

    document.getElementById("uv-pop-temp").innerText = temp + "°C";
    document.getElementById("uv-pop-value").innerText = uv;
    document.getElementById("uv-pop-location").innerText = location;

    let message = "";
    let desc = "";

    if (uv <= 2) {
      message = "Low UV exposure";
      desc = "Daily protection still matters.";
    } else if (uv <= 5) {
      message = "Moderate UV — protect your skin";
      desc = "Apply sunscreen before stepping out.";
    } else if (uv <= 7) {
      message = "High UV — your skin is under stress";
      desc = "Reapply every 2 hours.";
    } else {
      message = "Very high UV — intense damage risk";
      desc = "SPF 50+ is essential right now.";
    }

    document.getElementById("uv-pop-message").innerText = message;
    document.getElementById("uv-pop-desc").innerText = desc;

    showUVPopup();

  } catch (err) {
    console.log(err);
  }
}

loadUVPopup();